import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";

import theme from "../../../themes/theme.module.css";

// small outlined button with newer mui Button (v7).
const SmallOutlinedButton = ({ label, callback, sx }) => {
  const btnsx = {
    textTransform: "none",
    fontFamily: "Public Sans",
    fontWeight: 600,
    fontSize: 14,
    borderColor: theme.lake500,
    color: theme.lake500,
    "&:hover": {
      backgroundColor: theme.lake600,
      color: "#FFFFFF",
      borderColor: theme.lake600,
      boxShadow: "1px 1px 2px 1px RGB(100,100,100,0.2)",
    },
    "&:active": {
      backgroundColor: theme.lake700,
    },

    ...sx,
  };

  return (
    <Button color="primary" variant="outlined" onClick={callback} sx={btnsx}>
      {label}
    </Button>
  );
};
export default SmallOutlinedButton;

SmallOutlinedButton.defaultProps = {
  sx: {},
};

SmallOutlinedButton.propTypes = {
  label: PropTypes.string.isRequired,
  callback: PropTypes.func.isRequired,
  sx: PropTypes.shape(),
};
